import { createContext } from 'react';
import { RhumbAction, RhumbActionMarkerMounted, ReporterAction } from './types';

export type { RhumbActionMarkerMounted };

export interface RhumbContextValue {
  id: number;
  dispatch: (action: RhumbAction) => void;
  reportAction: (action: ReporterAction) => void;
  trackVisibility?: boolean;
  markerQueue: RhumbActionMarkerMounted[];
}

export const flushMarkerQueue = (
  markerQueue: RhumbActionMarkerMounted[],
  dispatch: (action: RhumbAction) => void
): void => {
  while (markerQueue.length > 0) {
    dispatch(markerQueue.shift()!);
  }
};

export default createContext<RhumbContextValue>({
  id: 0,
  dispatch: () => {},
  reportAction: () => {},
  trackVisibility: false,
  markerQueue: [],
});
